enum FWU_TARGET_TYPES {
    CHARGER_OR_MONO = 'CHARGER_OR_MONO',
    HOLDER_DEVICE = 'HOLDER_DEVICE',
    HOLDER_ENGINE = 'HOLDER_ENGINE',
    MONO_ENGINE = 'MONO_ENGINE',
    BLE_STACK = 'BLE_STACK',
}

export default FWU_TARGET_TYPES;
